var React = require('react');

function ArrowDiagonalWhite (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#FFFFFF","d":"M12,24C5.4,24,0,18.6,0,12C0,5.4,5.4,0,12,0c6.6,0,12,5.4,12,12C24,18.6,18.6,24,12,24z M12,1C5.9,1,1,5.9,1,12\n\ts4.9,11,11,11s11-4.9,11-11S18.1,1,12,1z","key":0}),React.createElement("polygon",{"fill":"#FFFFFF","points":"9.7,6.9 9.7,7.9 15.3,7.9 7.4,15.9 8.1,16.6 16.1,8.7 16.1,14.3 17.1,14.3 17.1,6.9 ","key":1})]);
}

ArrowDiagonalWhite.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 24 24","style":{"enableBackground":"new 0 0 24 24"},"xmlSpace":"preserve"};

module.exports = ArrowDiagonalWhite;

ArrowDiagonalWhite.default = ArrowDiagonalWhite;
